define('specific/staticproduct/views/StaticProductView', [
    'specific/staticproduct/templates/staticproduct',
    'components/factory/Factory'
], function(tpl, Factory) {

    var StaticProductView = Mazarine.View.extend({

        events: {
        },

        template: tpl,

        className: 'maz-staticproduct-view'
    });

    return StaticProductView;
});
